import $ from "jquery";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import API_BASE_URL from "../../../helper.js";

// Function to show success modal
function showSuccessModal(message) {
    $("#successMessage").text(message);
    const modal = new window.bootstrap.Modal(document.getElementById("successModal"));
    modal.show();
}

// ✅ MOVE FUNCTION OUTSIDE
function loadAllBlogs() {
    $.ajax({
        url: `${API_BASE_URL}/api/blog/all`,
        type: "GET",
        success: function (blogs) {
            let rows = "";
            blogs.reverse().forEach((b, i) => {
                rows += `
                    <tr>
                        <td>${i + 1}</td>
                        <td><img src="${API_BASE_URL}/assets/Images/${b.image}" width="80" /></td>
                        <td>${b.heading}</td>
                        <td>${b.subHeading}</td>
                        <td>${b.description}</td>
                        <td>${b.title}</td>
                        <td>
                            <button class="btn btn-primary btn-sm editBlogBtn" data-id="${b.id}">Edit</button>
                            <button class="btn btn-danger btn-sm deleteBlog" data-id="${b.id}">Delete</button>
                        </td>
                    </tr>
                `;
            });

            $("#allBlogData").html(rows);
        },
        error: function (err) {
            console.error(err);
        }
    });
}

// ✅ EXPOSE TO REACT
window.loadBlogs = function () {
    loadAllBlogs();
};

$(document).ready(function () {

    // ADD BLOG
    $("#addBlogForm").submit(function (e) {
        e.preventDefault();

        const formData = new FormData();
        formData.append("heading", $("#heading").val());
        formData.append("subHeading", $("#subHeading").val());
        formData.append("title", $("#title").val());
        formData.append("description", $("#description").val());
        formData.append("image", $("#image")[0].files[0]);

        $.ajax({
            url: `${API_BASE_URL}/api/blog/add`,
            type: "POST",
            data: formData,
            contentType: false,
            processData: false,
            success: function () {
                showSuccessModal("Blog Added Successfully!");
                $("#addBlogForm")[0].reset();

                const modal = window.bootstrap.Modal.getInstance(document.getElementById("blogModal"));
                modal.hide();
                loadAllBlogs();
            },
            error: function (err) {
                console.error(err);
                alert("Failed to add Blog!");
            }
        });
    });

    // OPEN EDIT MODAL
    $(document).on("click", ".editBlogBtn", function () {
        const id = $(this).data("id");

        $.ajax({
            url: `${API_BASE_URL}/api/blog/get/${id}`,
            type: "GET",
            success: function (b) {

                $("#editId").val(b.id);
                $("#editHeading").val(b.heading);
                $("#editSubHeading").val(b.subHeading);
                $("#editTitle").val(b.title);
                $("#editDescription").val(b.description);

                new window.bootstrap.Modal(document.getElementById("editBlogModal")).show();
            },
            error: () => alert("Failed to fetch blog data")
        });
    });

    // UPDATE BLOG
    $("#editBlogForm").submit(function (e) {
        e.preventDefault();

        const id = $("#editId").val();
        const formData = new FormData();

        formData.append("heading", $("#editHeading").val());
        formData.append("subHeading", $("#editSubHeading").val());
        formData.append("title", $("#editTitle").val());
        formData.append("description", $("#editDescription").val());

        if ($("#editImage")[0].files.length > 0) {
            formData.append("image", $("#editImage")[0].files[0]);
        }

        $.ajax({
            url: `${API_BASE_URL}/api/blog/update/${id}`,
            type: "POST",
            contentType: false,
            processData: false,
            data: formData,
            success: function () {
                showSuccessModal("Blog Updated Successfully!");
                loadAllBlogs();
                window.bootstrap.Modal.getInstance(document.getElementById("editBlogModal")).hide();
            },
            error: () => alert("Failed to update blog")
        });
    });
    
    // DELETE BLOG
    $(document).on("click", ".deleteBlog", function () {
        let id = $(this).data("id");

        if (!window.confirm("Are you sure want to delete this blog?")) return;

        $.ajax({
            url: `${API_BASE_URL}/api/blog/delete/${id}`,
            type: "DELETE",
            success: function () {
                showSuccessModal("Blog Deleted Successfully!");
                loadAllBlogs();
            },
            error: function (err) {
                console.error(err);
                alert("Failed to delete blog!");
            }
        });
    });

});

// import $ from "jquery";
// import "bootstrap/dist/js/bootstrap.bundle.min.js";
// import API_BASE_URL from "../../../helper.js";

// // Function to show success modal
// function showSuccessModal(message) {
//     $("#successMessage").text(message);
//     const modal = new window.bootstrap.Modal(document.getElementById("successModal"));
//     modal.show();
// }

// window.loadBlogs = function () {
//     loadAllBlogs();
// };

// $(document).ready(function () {

//     // ADD BLOG
//     $("#addBlogForm").submit(function (e) {
//         e.preventDefault();

//         const formData = new FormData();
//         formData.append("heading", $("#heading").val());
//         formData.append("subHeading", $("#subHeading").val());
//         formData.append("title", $("#title").val());
//         formData.append("description", $("#description").val());
//         formData.append("image", $("#image")[0].files[0]);

//         $.ajax({
//             url: `${API_BASE_URL}/api/blog/add`,
//             type: "POST",
//             data: formData,
//             contentType: false,
//             processData: false,
//             success: function () {
//                 showSuccessModal("Blog Added Successfully!");
//                 $("#addBlogForm")[0].reset();

//                 const modal = window.bootstrap.Modal.getInstance(document.getElementById("blogModal"));
//                 modal.hide();
//                 loadAllBlogs();
//             },
//             error: function (err) {
//                 console.error(err);
//                 alert("Failed to add Blog!");
//             }
//         });
//     });

//     // LOAD ALL BLOG DATA
//     function loadAllBlogs() {
//         $.ajax({
//             url: `${API_BASE_URL}/api/blog/all`,
//             type: "GET",
//             success: function (blogs) {
//                 let rows = "";
//                 blogs.reverse().forEach((b, i) => {
//                     rows += `
//                         <tr>
//                             <td>${i + 1}</td>
//                             <td><img src="${API_BASE_URL}/assets/Images/${b.image}" width="80" /></td>
//                             <td>${b.heading}</td>
//                             <td>${b.subHeading}</td>
//                             <td>${b.description}</td>
//                             <td>${b.title}</td>
//                             <td>
//                                 <button class="btn btn-primary btn-sm editBlogBtn" data-id="${b.id}">Edit</button>
//                                 <button class="btn btn-danger btn-sm deleteBlog" data-id="${b.id}">Delete</button>
//                             </td>
//                         </tr>
//                     `;
//                 });

//                 $("#allBlogData").html(rows);
//             },
//             error: function (err) {
//                 console.error(err);
//             }
//         });
//     }

//     // OPEN EDIT MODAL
//     $(document).on("click", ".editBlogBtn", function () {
//         const id = $(this).data("id");

//         $.ajax({
//             url: `${API_BASE_URL}/api/blog/get/${id}`,
//             type: "GET",
//             success: function (b) {

//                 $("#editId").val(b.id);
//                 $("#editHeading").val(b.heading);
//                 $("#editSubHeading").val(b.subHeading);
//                 $("#editTitle").val(b.title);
//                 $("#editDescription").val(b.description);

//                 new window.bootstrap.Modal(document.getElementById("editBlogModal")).show();
//             },
//             error: () => alert("Failed to fetch blog data")
//         });
//     });

//     // UPDATE BLOG
//     $("#editBlogForm").submit(function (e) {
//         e.preventDefault();

//         const id = $("#editId").val();
//         const formData = new FormData();

//         formData.append("heading", $("#editHeading").val());
//         formData.append("subHeading", $("#editSubHeading").val());
//         formData.append("title", $("#editTitle").val());
//         formData.append("description", $("#editDescription").val());

//         if ($("#editImage")[0].files.length > 0) {
//             formData.append("image", $("#editImage")[0].files[0]);
//         }

//         $.ajax({
//             url: `${API_BASE_URL}/api/blog/update/${id}`,
//             type: "POST",
//             contentType: false,
//             processData: false,
//             data: formData,
//             success: function () {
//                 showSuccessModal("Blog Updated Successfully!");
//                 loadAllBlogs();
//                 window.bootstrap.Modal.getInstance(document.getElementById("editBlogModal")).hide();
//             },
//             error: () => alert("Failed to update blog")
//         });
//     });
    
//     // DELETE BLOG
//     $(document).on("click", ".deleteBlog", function () {
//         let id = $(this).data("id");

//         if (!window.confirm("Are you sure want to delete this blog?")) return;

//         $.ajax({
//             url: `${API_BASE_URL}/api/blog/delete/${id}`,
//             type: "DELETE",
//             success: function () {
//                 showSuccessModal("Blog Deleted Successfully!");
//                 loadAllBlogs();
//             },
//             error: function (err) {
//                 console.error(err);
//                 alert("Failed to delete blog!");
//             }
//         });
//     });

// });

